import { Add } from "@mui/icons-material";
import { Box, Button, Chip, Grid, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ERROR, SOMETHING_WENT_WRONG } from "../../utils/constants";
import { SAVE_MEDICINE_INFO } from "../../utils/constants/redux";
import AHMIS, { API_URL } from "../../api/api";
import AddAlertMessage from "../alert/Alert";
import CustomReactSelect from "../custom-react-select/CustomReactSelect";

export default function AddMedicineList(props) {
  const [medicineName, setMedicineName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const dispatch = useDispatch();
  const medicineList = useSelector((state) => state.medicineInfo);
  const medicineOptions = medicineList?.map((item) => ({ value: item.medicineName, label: item.medicineName })) || [];

  useEffect(() => {
    if (!medicineList) {
      AHMIS.get(API_URL.medicineList)
        .then((response) => {
          const objectList = response.data?.data?.objectList;
          dispatch({ type: SAVE_MEDICINE_INFO, payload: objectList });
        })
        .catch(() => {
          AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        });
    }
  }, []);

  const handleQuantityChange = event => {
    setQuantity(event.target.value);
  }

  const removeMedicineObject = item => {
    let medicineListAfterRemoval = props.medicineDetails.filter((medicineObject) => {
      return medicineObject.medicineName !== item.medicineName || medicineObject.quantity !== item.quantity;
    });
    props.onAddmedicineDetails(medicineListAfterRemoval);
  }

  function addAndClear(medicineObject) {
    props.onAddmedicineDetails(prev => [
      ...(Array.isArray(prev) ? prev : []),
      medicineObject,
    ]);

    setMedicineName("");
    setQuantity("");
    setShowErrorMessage(false);
  }

  const addToList = () => {
    if (medicineName && quantity) {
      addAndClear({ medicineName, quantity })
    } else {
      setShowErrorMessage(true);
    }
  }

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={4}>
          <CustomReactSelect
            name="medicineName"
            label="Medicine Name"
            options={medicineOptions}
            defaultValue={medicineName}
            onChange={(_name, value) => setMedicineName(value)}
            creatable
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            size="small"
            type="number"
            onWheel={(e) => e.target.blur()}
            value={quantity}
            label="Quantity"
            placeholder="Eg: 10"
            name="quantity"
            variant="outlined"
            onChange={handleQuantityChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Button size="small" type="button" variant="contained" color="primary" startIcon={<Add />} onClick={addToList}>{props.addToListButtonText}</Button>
        </Grid>
      </Grid>
      {
        showErrorMessage &&
        <span className="error-message">{props.requiredErrorMessage}</span>
      }
      <Box mt={2}>
        {
          props?.medicineDetails?.map((item, index) => (
            <Chip
              key={index}
              label={`${item.medicineName} - ${item.quantity}`}
              onDelete={() => removeMedicineObject(item)}
            />
          ))
        }
      </Box>
    </Box>
  );
}

AddMedicineList.propTypes = {
  addToListButtonText: PropTypes.string,
  requiredErrorMessage: PropTypes.string,
};

AddMedicineList.defaultProps = {
  addToListButtonText: "Add To List",
  requiredErrorMessage: "कृपया औषधीको नाम र संख्या चयन गर्नुहोस्।"
};